import { ProductlistPage } from './themes/BGH/productlistPage';
export default ProductlistPage;
